import priceSelectionList from '../utils/getPriceSelectionList';
import getTotalsForSetOfTotals from '../utils/getTotalsForSetOfTotals';
import { pricingFields } from './fibreInternetFieldNames';

export const getFibreInternetTotals = (formFields, orderData) => {
  const customerInformationTotals = getTotalsForSetOfTotals(
    pricingFields,
    formFields,
    orderData
  );
  return customerInformationTotals;
};

export const getFibreInternetPriceSelections = formFields => {
  const selectionsList = priceSelectionList(pricingFields, formFields);
  return selectionsList;
};
